import { db } from '@/main';
import moment from 'moment'

const state = {
    todo : []
}

// getters
const getters = {
}

// mutations
const mutations = {
    accessActiveArena:(state, payload)=>{
        const updateRef = db.collection('User').doc(payload);
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.accessStatus.arena == true){
                    updateRef.update({ 'accessStatus.arena': false })        
                }
                else if(list.accessStatus.arena == false){
                    updateRef.update({ 'accessStatus.arena': true })
                }
            }
        })
    },
    accessActiveCoupon:(state, payload)=>{
        const updateRef = db.collection('User').doc(payload);
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.accessStatus.coupon == true){
                    updateRef.update({ 'accessStatus.coupon': false })        
                }
                else if(list.accessStatus.coupon == false){
                    updateRef.update({ 'accessStatus.coupon': true })
                }
            }
        })
    },
    accessActiveGift:(state, payload)=>{
        const updateRef = db.collection('User').doc(payload);
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.accessStatus.gift == true){
                    updateRef.update({ 'accessStatus.gift': false })        
                }
                else if(list.accessStatus.gift == false){
                    updateRef.update({ 'accessStatus.gift': true })
                }
            }
        })
    },
    accessActiveMail:(state, payload)=>{
        const updateRef = db.collection('User').doc(payload);
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.accessStatus.mail == true){
                    updateRef.update({ 'accessStatus.mail': false })        
                }
                else if(list.accessStatus.mail == false){
                    updateRef.update({ 'accessStatus.mail': true })
                }
            }
        })
    },
    accessActiveRank:(state, payload)=>{
        const updateRef = db.collection('User').doc(payload);
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.accessStatus.rank == true){
                    updateRef.update({ 'accessStatus.rank': false })        
                }
                else if(list.accessStatus.rank == false){
                    updateRef.update({ 'accessStatus.rank': true })
                }
            }
        })
    },
    accessActiveTalk:(state, payload)=>{
        const updateRef = db.collection('User').doc(payload);
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.accessStatus.talk == true){
                    updateRef.update({ 'accessStatus.talk': false })        
                }
                else if(list.accessStatus.talk == false){
                    updateRef.update({ 'accessStatus.talk': true })
                }
            }
        })
    },                    

    taskActive:(state,payload)=>{
        var updatestatus = "";
        state.todo.find(function (list) {
            if (list.id == payload) {
                if(list.status == 'ACTIVE'){
                    updatestatus = 'INACTIVE'
                }
                else if(list.status == 'INACTIVE'){
                    updatestatus = 'ACTIVE'
                }
            }
        })

        const updateRef = db.collection('User').doc(payload);
        updateRef.update({ status:updatestatus })
    },

    tododelete:(state,payload)=>{
        db.collection('User').doc(payload).delete()
    },

    addtodo:(state, payload)=>
    {        
        if (payload.notice_link == null)payload.notice_link = ""
        if (payload.notice_image == null)payload.notice_image = ""

        if (payload.message_korean == null)payload.message_korean = ""
        if (payload.message_spanish == null)payload.message_spanish = ""
        if (payload.message_portuguese == null)payload.message_portuguese = ""
        if (payload.message_french == null)payload.message_french = ""
        if (payload.message_german == null)payload.message_german = ""
        if (payload.message_russian == null)payload.message_russian = ""

        db.collection('User').add({ 
                        
            market: payload.notice_market,
            versionCode: payload.notice_versionCode,
            deadline : payload.notice_deadline,
            link: payload.notice_link,
            image: payload.notice_image,

            message: 
            {
                english : payload.message_english,
                korean : payload.message_korean,
                spanish : payload.message_spanish,
                portuguese : payload.message_portuguese,
                french : payload.message_french,
                german : payload.message_german,
                russian : payload.message_russian                
            },             
               
            status : 'INACTIVE',
            created: new Date()
        })
    },

    retrieveTodos(state,todos){
        state.todo = todos
    }
 
};

// actions
const actions = {
    retrieveTodos:(context)=>{
        db.collection('User').orderBy('joinDate', 'desc').limit(10).get()
        .then((querySnapshot)=>{
            var tempTodos = []

            querySnapshot.forEach((doc)=>{
                //tempTodos.push(doc.data());
                //tempTodos.push({ id:doc.id, title:doc.data().title, delete:doc.data().delete, status:doc.data().status, created:doc.data().created });

                tempTodos.push({ 
                    id:doc.id, 
                    userUid:doc.data().userUid,
                    userType:doc.data().userType,
                    userName:doc.data().userName,
                    userPhotoUrl:doc.data().userPhotoUrl,
                    level:doc.data().level,
                    country:doc.data().country,
                    language:doc.data().language,
                    goods:doc.data().goods,
                    accessStatus:doc.data().accessStatus,
                    loginDate:moment(String(doc.data().loginDate.toDate())).format('YYYY-MM-DD hh:mm'),                    
                    joinDate:moment(String(doc.data().joinDate.toDate())).format('YYYY-MM-DD hh:mm'),
                    status:doc.data().status                    
                });                
            })

            var tempTodosSorted = tempTodos.sort((a,b)=>{
                return a.loginDate.seconds - b.loginDate.seconds
            })

            context.commit('retrieveTodos',tempTodosSorted)
        })
    },
    accessActiveArena:(context, payload) => {
        context.commit('accessActiveArena',payload)
    },
    accessActiveCoupon:(context, payload) => {
        context.commit('accessActiveCoupon',payload)
    },
    accessActiveGift:(context, payload) => {
        context.commit('accessActiveGift',payload)
    },    
    accessActiveMail:(context, payload) => {
        context.commit('accessActiveMail',payload)
    },
    accessActiveRank:(context, payload) => {
        context.commit('accessActiveRank',payload)
    },
    accessActiveTalk:(context, payload) => {
        context.commit('accessActiveTalk',payload)
    },
    
    
    taskActive:(context, payload) => {
        context.commit('taskActive',payload)
    },
    alltaskcomplete:(context,payload) => {
        context.commit('alltaskcomplete',payload)
    },
    tododelete:(context, payload) => {
        context.commit('tododelete',payload)
    },
    addtodo:(context, payload) => {
        context.commit('addtodo', payload)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}